export default __webpack_public_path__ + "static/media/amparo-arte-2.e1a8ff49.webp";